module.exports = {
	"$id": "content.json#",
	"$schema": "http://json-schema.org/draft-06/schema#",
	"type": "object",
	"required": [
		"size",
		"mimeType"
	],
	"properties": {
		"size": {
			"type": "integer"
		},
		"compression": {
			"type": "integer"
		},
		"mimeType": {
			"type": "string"
		},
		"text": {
			"type": "string"
		},
		"encoding": {
			"type": "string"
		},
		"comment": {
			"type": "string"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/har-schema/lib/content.json
// module id = 669
// module chunks = 0